import { useCallback } from 'react';
import { useFormikContext } from 'formik';

import type { Id } from '@e-socna/data-layer';

import type { ThirdPartyForm_ThirdParty } from '../../../fragments/third-party.fragment';

export const useFindAddressIndexById = () => {
  const { values } = useFormikContext<ThirdPartyForm_ThirdParty>();

  const findIndexById = useCallback(
    (id: Id) => values.addresses.findIndex((address) => address._id === id),
    [values.addresses],
  );

  return findIndexById;
};
